import { render } from "./DialogCustGroups.vue?vue&type=template&id=17cce198"
import script from "./DialogCustGroups.vue?vue&type=script&lang=js"
export * from "./DialogCustGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__